export const MediaConfig = {
    story: {
        coverImage: 'default.png',
        voiceAudio: 'voice_{lang}.mp3',
        mixedAudio: 'default_{lang}.mp3',
        externalAudio: 'external_{lang}.mp3',
        storyAnnounce: 'announce_{lang}.mp3',
    },
    show: {
        coverImage: 'default.png',
        introMusic: 'intro.mp3',
        outroMusic: 'outro.mp3',
        backgroundMusic: 'background-music.mp3',
        themeMusic: 'theme.mp3',
        showAnnounce: 'announce_{lang}.mp3',
    },
    insert: {
        coverImage: 'default.webp',
        audio: 'default_{lang}.mp3',
    },
};
export function getConventionalFilename(entityType, mediaType, lang) {
    const config = MediaConfig[entityType];
    if (!config) {
        throw new Error(`Invalid entity type: ${entityType}`);
    }
    const filename = config[mediaType];
    if (!filename) {
        throw new Error(`Invalid media type "${mediaType}" for entity type "${entityType}"`);
    }
    if (lang && filename.includes('{lang}')) {
        return filename.replace('{lang}', lang);
    }
    return filename;
}
export const TimestampFieldMap = {
    story: {
        coverImage: 'image_updated_at',
        voiceAudio: 'voice_audio_updated_at',
        mixedAudio: 'mixed_audio_updated_at',
        externalAudio: 'external_audio_updated_at',
        storyAnnounce: 'announce_updated_at',
    },
    show: {
        coverImage: 'image_updated_at',
        introMusic: 'intro_music_updated_at',
        outroMusic: 'outro_music_updated_at',
        backgroundMusic: 'music_updated_at',
        themeMusic: 'theme_music_updated_at',
        showAnnounce: 'announce_updated_at',
    },
    insert: {},
};
export function getTimestampField(entityType, mediaType) {
    const config = TimestampFieldMap[entityType];
    if (!config) {
        throw new Error(`Invalid entity type: ${entityType}`);
    }
    const fieldName = config[mediaType];
    if (!fieldName) {
        throw new Error(`Invalid media type "${mediaType}" for entity type "${entityType}"`);
    }
    return fieldName;
}
//# sourceMappingURL=media-config.js.map